import { Box, styled } from '@mui/material';

export const HomePageContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100vh',

  [theme.breakpoints.down('md')]: {
    minHeight: '-webkit-fill-available',
    height: '-webkit-fill-available',
  },
}));

export const LeftSideContainerStyled = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[100],

  '&.signUpSignin': {
    padding: '30px 40px',
  },
}));

export const LeftSideLogoContainerStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '30px 40px',

  '&.signUpSignin': {
    padding: 0,
  },
}));

export const LeftSidePictureContainerStyled = styled(Box)(({ theme }) => ({
  width: '60%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 'auto' /* 把多餘空間推到上方 */,
  marginBottom: 'auto' /* 再把剩餘空間推到底部 → 視覺上就會垂直置中 */,
  '&.signUpSignin': {
    width: '100%',
  },
}));

export const LeftSidePictureStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  marginBottom: '24px',

  '&.signUpSignin': {
    marginBottom: 0,
  },
}));

export const SmallLogoContainerStyled = styled(Box)(({ theme }) => ({
  alignSelf: 'center',
  padding: '12px 0',

  '&.signUpSignin': {
    padding: 0,
  },
}));
